import { Document } from '../../jurisdiction/jurisdiction.domain';
import { IEnergyProducerUnit } from './interfaces/energyProducerUnit';
import { GridApplicationDocumentTypes } from './enums/grid-application-document-types.enum';

export class StoragePowerConverter implements IEnergyProducerUnit {
  constructor() {
    this.documents = [];
    this.documents.push(new Document(GridApplicationDocumentTypes.EnergyUnitDataSheet));
    this.documents.push(new Document(GridApplicationDocumentTypes.UnitCertificate));
    this.documents.push(new Document(GridApplicationDocumentTypes.AuditReport));
  }

  id: number;
  manufacturer: string;
  type: string;
  identical_units: number;
  effective_power: number;
  documents: Document[];
}
